import $ from 'jquery'

$(function () {
    $('.js-profession').hover(
        function () {
            const $parent = $(this).parent();

            $parent.find('.js-profession')
                .removeClass('active inactive');

            $(this).addClass('active');
            $parent.find('.js-profession').not(this).addClass('inactive');
        },
        function () {
            const $parent = $(this).parent();

            $parent.find('.js-profession')
                .removeClass('active inactive');
        }
    );
});